import { Injectable, NgModule } from '@angular/core';

@NgModule()
@Injectable({
  providedIn: 'root',
})
export  class UrlsConfig {

   public static readonly API_ENDPOINT = 'https://bi-dev-api.ordesoft.com/api/';
}
